import { render, staticRenderFns } from "./OneClickBuyForm.vue?vue&type=template&id=955d4438&lang=pug&"
import script from "./OneClickBuyForm.vue?vue&type=script&lang=js&"
export * from "./OneClickBuyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports